export const DASHBOARD_START = 'dashboard/dashboard-start';
export const DASHBOARD_SUCCESS = 'dashboard/dashboard-success';
export const DASHBOARD_ERROR = 'dashboard/dashboard-error';
